import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { ContentsCoverImageResponseDto } from '@diritto/common/content/dtos/content-cover-image.response.dto';
import { ContentSynopsisEditDto, ContentSynopsisResponseDto } from '@diritto/common/content/dtos/content-synopsis.dto';
import { ContentEditDto } from '@diritto/common/content/dtos/content.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { WsContentResponseDto, WsContentsResponseDto } from '@diritto/common/content/dtos/ws-content.dto';
import { AxiosRequestConfig } from 'axios';

export class WsContentApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async createContent(data: ContentEditDto) {
    const res = await this.http.post<ContentEditDto, WsContentResponseDto>(`${this.url}/contents`, data);
    return res.data;
  }

  async updateContent(contentId: number, data: ContentEditDto) {
    const res = await this.http.put<ContentEditDto, WsContentResponseDto>(`${this.url}/contents/${contentId}`, data);
    return res.data;
  }

  async deleteContent(contentId: number) {
    const res = await this.http.delete(`${this.url}/contents/${contentId}`);
    return res.data;
  }

  async uploadCoverFiles(data: FormData): Promise<ContentsCoverImageResponseDto> {
    const res = await this.http.post<FormData, ContentsCoverImageResponseDto>(`${this.url}/contents/covers`, data);
    return res.data;
  }

  async getSynopsis(contentId: number) {
    const res = await this.http.get<ContentSynopsisResponseDto>(`${this.url}/workspace/contents/${contentId}/synopsis`);
    return res.data;
  }

  async updateSynopsis(contentId: number, data: ContentSynopsisEditDto) {
    const res = await this.http.put<ContentSynopsisEditDto, ResponseDto>(
      `${this.url}/workspace/contents/${contentId}/synopsis`,
      data,
    );
    return res.data;
  }

  async getWsContents(paginator?: BasePaginatorDto, options?: AxiosRequestConfig): Promise<WsContentsResponseDto> {
    const res = await this.http.get<WsContentsResponseDto>(`${this.url}/workspace/contents`, {
      params: paginator,
      ...options,
    });
    return res.data;
  }

  async updateContestContentSynopsis(contentId: number, contestId: number, data: ContentSynopsisEditDto) {
    const res = await this.http.put<ContentSynopsisEditDto, ResponseDto>(
      `${this.url}/contests/${contestId}/contents/${contentId}/synopsis`,
      data,
    );
    return res.data;
  }

  async applyContest(contestId: number, contentId: number) {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/contests/${contestId}/contents/${contentId}/apply`,
    );
    return res.data;
  }

  async withdrawContest(contestId: number, contentId: number) {
    const res = await this.http.post<undefined, ResponseDto>(
      `${this.url}/contests/${contestId}/contents/${contentId}/withdraw`,
    );
    return res.data;
  }
}
